// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\equipment.org.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\equipment.org.tsx");
  import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

export const meta = () => {
  return [{
    title: "Equipment | Nomadics"
  }, {
    name: "description",
    content: "Professional equipment for rent"
  }];
};
export default function Equipment() {
  return <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Equipment</h1>
      <p className="text-lg text-muted-foreground">
        Browse our professional equipment available for rent.
      </p>
    </div>;
}
_c = Equipment;
var _c;
$RefreshReg$(_c, "Equipment");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;